// Error and system text kept out of the page's flow (S131): long output under a timeline entry
// or a step pushed the layout around, so it shows as one summary line and opens in a dialog.

export type OutputKind = "error" | "output" | "system";

export interface OutputBlock {
  kind: OutputKind;
  text: string;
}

/** Longer than this, or on several lines, and text is folded rather than shown in place. */
export const INLINE_LIMIT = 120;

/** The first non-blank line, cut to `max` characters with an ellipsis. */
export function summaryLine(text: string, max = INLINE_LIMIT): string {
  const first = text.split("\n").find((l) => l.trim() !== "")?.trim() ?? "";
  return first.length > max ? `${first.slice(0, max - 1).trimEnd()}…` : first;
}

/** Whether `text` would not sit on one short line. */
export function isLong(text: string): boolean {
  return text.length > INLINE_LIMIT || text.trim().includes("\n");
}
